import store from '../state/store' 
export default [
  {
    path: '/login',
    name: 'login', 
    component: () => import('./views/account/login'),  
    beforeEnter(to,from,next){  
        if(!store.getters.["auth/isAuth"]){
          next()
        }else{
          next("/")
        }
    }
  }, 
  {
    path: '/logout',
    name: 'logout', 
    beforeEnter(to,from,next){  
    store.dispatch("auth/logOut") 
        next("/login") 
    },
     
  },
  {
    path: '/',
    name: 'default', 
    component: () => import('./views/welcome/index'), 
    beforeEnter(to,from,next){   
        if(store.getters.["auth/isAuth"]){
          next()
          //window.location.href = "https://anket.giresun.edu.tr";
        }else{
          next("/login") 
        }
    }
  },
  {
    path: '/userroles',
    name: 'userroles', 
    component: () => import('./views/userroles/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next()
          //window.location.href = "https://anket.giresun.edu.tr";
          }else{
            next("/login") 
          }
     }
  }, 
  {
    path: '/ouserbirimyetki',
    name: 'ouserbirimyetki', 
    component: () => import('./views/ouserbirimyetki/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next()
          //window.location.href = "https://anket.giresun.edu.tr";
          }else{
            next("/login") 
          }
     }
  },
  {
    path: '/userswebsiteyetki',
    name: 'userswebsiteyetki', 
    component: () => import('./views/userswebsiteyetki/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next()
          //window.location.href = "https://anket.giresun.edu.tr";
          }else{
            next("/login") 
          }
     }
  },
 
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  }, 
  {
    path: '*',
    redirect: '404',
  }
  
]
